import Loading from "@components/common/Loading";
import Notification from "@components/common/Notification";
import { API_URL } from "@redux/api";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { NotificationType } from "react-app-env";
import { NavLink } from "react-router-dom"

export type InventoryCategoriesList = {
  _id: string;
  label: string;
  totalItems: number;
}[];

const DataBarangRoute = () => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notification, setNotification] = useState<NotificationType | null>(null);
  
  const [categoryList, setCategoryList] = useState<InventoryCategoriesList>([]);

  const fetchCategoryList = useCallback(async () => {
    setIsLoading(true);
    const response = await axios.get(`${API_URL}/inventory/category/list`);

    const { status, data } = response;

    if (status === 200) {
      setCategoryList(data.data)
      setIsLoading(false);
    } else {
      setNotification({
        isError: true,
        title: "Error",
        text: data.message,
      })
    }
  }, []);

  useEffect(() => {
    fetchCategoryList();
    return () => { }
  }, [fetchCategoryList]);

  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <h1 className="text-center text-xl md:text-2xl lg:text-4xl font-semibold">Data Barang</h1>
      </div>

      <div className="mt-10">
        <Notification notification={notification} />
      </div>
      
      { isLoading ?
        <div className="mt-10 bg-white py-14 rounded-xl">
          <Loading loading={isLoading} type='beat-loader' size={10} parentClass='text-sm' />
        </div>
        : <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {categoryList.map(category => {
            return (
              <NavLink
                key={category._id}
                to={`/data-barang/${category._id}`}
                className="flex items-center justify-center py-5 bg-white rounded-xl hover:bg-gray-200 transition-all ease-in-out duration-300 hover:scale-105"
              >
                <h3 className="font-semibold capitalize">{category.label}</h3>
              </NavLink>
            )
          })}
        </div>
      }
    </div>
  )
}

export default DataBarangRoute